// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__1lYK_","video":"video_video__3GXNy","videoPlayer":"video_videoPlayer__m1_Oz"};